module.exports = __webpack_public_path__ + "mainassets/img/mailbox.1f525b91.svg";